// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ActiveState, SeoAppProps } from "@conklin/App/Widgets/SearchEngineOptimization/Type";
import { GetBrandCategoriesApiParameter } from "@insite/client-framework/Services/BrandService";
import { getSelectedBrandPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getAllBrandsDataView,
    getBrandCategoriesDataView,
    getBrandStateByPath,
} from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

const getBrandActiveState = ({ state, currentPage, payload }: SeoAppProps): ActiveState => {
    const isBrandPage = currentPage.type === "BrandsPage";
    const isBrandDetail = currentPage.type === "BrandDetailsPage";

    if (isBrandPage) {
        payload.brands = getAllBrandsDataView(state)?.value;
    }

    if (isBrandDetail) {
        const { pathname } = getLocation(state);
        const brandPath = getSelectedBrandPath(state) || pathname;
        const brandState = getBrandStateByPath(state, brandPath);

        if (!brandState.isLoading && brandState?.value) {
            payload.brands = [brandState.value];
        }

        const brandCategoriesParameter: GetBrandCategoriesApiParameter = {
            brandId: brandState.value?.id || "",
            page: 1,
            pageSize: 1000,
            sort: "name",
            maximumDepth: 3,
        };

        const brandCategoriesDataView = getBrandCategoriesDataView(state, brandCategoriesParameter);
        if (!brandCategoriesDataView.isLoading && brandCategoriesDataView?.value) {
            payload.brandCategories = brandCategoriesDataView.value;
        }
    }

    return (isBrandPage || isBrandDetail) && !!payload?.brands?.length;
};

export default getBrandActiveState;
